import { FC } from 'react';
import { Button, Box, Icon, useDisclosure } from "@chakra-ui/react";
import { IoShareSocialSharp } from '@react-icons/all-files/io5/IoShareSocialSharp';
import { useLoggedinUser } from "lib/hooks";
import { VerifyAlertDialog } from "components";

export const SharePackButton: FC<any> = ({ onOpen }) => {
  const { data: user } = useLoggedinUser();
  const verifyDialog = useDisclosure();

  const onClick = (): void => {
    user && !user.verified ? verifyDialog.onOpen() : onOpen();
  }

  return (
    <>
      <Button
        data-help="Your pack is private unless you want to share it. To invite someone to view, edit or be an admin on this specific pack, click here."
        onClick={onClick}
        variant={"primary"}
      >
        <Box display={['none', 'block']}>Share Pack</Box>
        <Box display={['block', 'none']}><Icon as={IoShareSocialSharp} fill="brand.500" boxSize="20px"/></Box>
      </Button>
      <VerifyAlertDialog
        isOpen={verifyDialog.isOpen}
        onClose={verifyDialog.onClose}
        content={`To share a pack, you need to complete your account set up. It’s super easy. We sent a verification link to ${user?.email}. Please go to your inbox and click that link to get full access to your Packs account.`}
        title={"You’re so close! One final step."}
      />
    </>
  )
};
